import { memo } from "react";
import { Popup, CircleMarker} from "react-leaflet";
import { getColorByDensity } from "./utils/getColorByDensity";
import { SpotPopupContent } from "./SpotPopupContent";
// Memoized Crime Marker Component
export const CrimeMarker = memo(({ spot, density, maxDensity, totalSpots, onSelect, config }) => {
    const latitude = Number(spot.latitude);
    const longitude = Number(spot.longitude);

    if (isNaN(latitude) || isNaN(longitude)) {
        return null;
    }

    const color = config?.marker?.color ?? getColorByDensity(density, maxDensity, totalSpots);
    
    // Calculate radius identically to how color ratio is calculated
    const normalizedDensity = Math.max(0, density - 1);
    const normalizedMax = Math.max(1, maxDensity - 1);
    const baselineMax = Math.max(5, Math.ceil(totalSpots * 0.05));
    const effectiveMax = Math.max(normalizedMax, baselineMax);
    const ratio = Math.min(normalizedDensity / effectiveMax, 1);
    
    const radius = density <= 1 ? 3 : 3 + (ratio * 2); // Radius between 3 and 9

    return (
        <CircleMarker
            center={[latitude, longitude]}
            radius={radius}
            fillColor={color}
            color={color}
            weight={config?.marker?.weight ?? 2}
            opacity={0.9}
            fillOpacity={0.7}
            eventHandlers={{
                click: () => onSelect(spot),
            }}
        >
            <Popup>
                <SpotPopupContent spot={spot} config={config} />
            </Popup>
        </CircleMarker>
    );
});

CrimeMarker.displayName = "CrimeMarker";